import Consulta from "./Consulta";

export default Consulta;
